export default __webpack_public_path__ + "static/media/automation-1-small.1605e23a.jpg";